import http from '@/http'

// Endpoint dedicado ao contexto de check-in: respeita allowed_tag_ids
// configurado por admin no perfil do operador. Vazio = todas (retrocompat).
// Endpoint genérico /admin/tags continua livre pra outras telas.
export async function fetchTags () {
  const response = await http.get('/admin/check-in/tags', { params: { limit: 1000 } })
  if (response.status !== 200) {
    const exc: any = { CODID: 'I8EEC0T9', response }
    exc['error'] = new Error(exc.CODID)
    throw exc
  }

  const tags = response.data.data

  return tags.map((tag: any) => ({
    id: tag.id,
    text: tag.name
  }))
}
